import { Label, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutMultiAssignCarrierQual extends Layout {
    labelMissing: Label;
    panelMissingInfo: Panel;
}
